import { FormControl, FormLabel, RadioGroup } from '@material-ui/core';
import { useInput } from 'react-admin';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import React, { useState } from 'react';

import {
  List,
  Datagrid,
  TextField,
  DeleteButton,
  Edit,
  TextInput,
  Button,
  Create,
  SimpleForm,
  TopToolbar,
  FormTab,
  TabbedForm,
  NumberInput,
  BooleanInput,
  DateTimeInput,
  FormDataConsumer,
  RadioButtonGroupInput,
  ResourceContextProvider,
  useCreate,
  useRefresh,
  useUpdate,
  FormWithRedirect,
  Toolbar,
  SaveButton,
  useNotify,
  useRedirect,
  ReferenceInput,
  SelectInput,
  ReferenceField,
  BooleanField,
  minValue,
  maxValue,
  required
} from 'react-admin';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import CardMembershipIcon from '@mui/icons-material/CardMembership';
import IconContentAdd from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import IconCancel from '@material-ui/icons/Cancel';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Box from '@material-ui/core/Box';
import { Link } from 'react-router-dom';
import RichTextInput from 'ra-input-rich-text';

import { useTranslate } from '../common/language';
import { targets } from './../common/constants';
import { dateParser } from '../common/utils';
import { DocsList } from './docs';
import { validateMaxLength } from './../components/Validator';

const SubscriptionTypeInput = () => {
  const translate = useTranslate();
  const { input } = useInput({ source: 'type', defaultValue: 0 });
  return (
    <FormControl component="fieldset" margin="dense">
      <FormLabel component="legend" id="subscription-type-label">{translate('common.type')}</FormLabel>
      <RadioGroup
        row
        aria-labelledby="subscription-type-label"
        name={input.name}
        value={Number(input.value || 0)}
        onBlur={input.onBlur}
        onChange={(_, value) => input.onChange(Number(value))}
      >
        <FormControlLabel value={0} control={<Radio color="primary" />} label={translate('events_subscriptions.type_code')} />
        <FormControlLabel value={1} control={<Radio color="primary" />} label={translate('events_subscriptions.type_tickets')} />
      </RadioGroup>
    </FormControl>
  );
};

const transformSubscriptionData = data => {
  const rawMode = data.allow_one_ticket_each_event;
  const oneTicketEachEvent = rawMode === undefined || rawMode === null
    ? true
    : rawMode === true || rawMode === 'true' || rawMode === 1 || rawMode === '1';
  return {
    ...data,
    type: data.type === undefined || data.type === null || data.type === '' ? 0 : Number(data.type),
    allow_one_ticket_each_event: oneTicketEachEvent,
    allow_limited_tickets: !oneTicketEachEvent,
    max_tickets: oneTicketEachEvent ? 0 : data.max_tickets
  };
};

export const SettingsEventsSubscriptions = (props) => {
  const translate = useTranslate();

  return (
    <>
      <br/>
      <Typography variant="h5" className="grey8" align="center">
        {translate('events_subscriptions.title')}
      </Typography>
      <Box sx={{ bgcolor: 'background.paper', padding: '20px' }} className="settings_box">
        <ResourceContextProvider value="events_subscriptions">
          <List
            {...props}
            basePath="/events_subscriptions"
            sort={{ field: 'priority', order: 'ASC' }}
            actions={<ListActions />}
            filter={{ associations_id: localStorage.getItem('associations_id') }}
            bulkActionButtons={false}
            empty={<ListActions />}
            fullWidth
          >
            <Datagrid rowClick="edit" fullWidth>
              <CardMembershipIcon />
              <TextField source="name" label={translate('common.name')} sortable={false} />
              <TextField source="events_count" label={translate('events_subscriptions.events_count')} sortable={false} />
              <TextField source="total_capacity" label={translate('events_subscriptions.total_capacity')} sortable={false} />
              <BooleanField source="actived" label={translate('common.actived')} sortable={false} />
              <DeleteButton undoable={false} redirect="/settings-events-subscriptions" label="" />
            </Datagrid>
          </List>
        </ResourceContextProvider>
      </Box>
    </>
  );
};

const ListActions = () => (
  <TopToolbar>
    <EventsSubscriptionsCreateButton />
  </TopToolbar>
);

const EventsSubscriptionsCreateButton = () => {
  const [showDialog, setShowDialog] = useState(false);
  const [create, { loading }] = useCreate('events_subscriptions');
  const notify = useNotify();
  const translate = useTranslate();
  const redirect = useRedirect();

  const handleSubmit = async values => {
    const data = transformSubscriptionData(values);
    create(
      { payload: { data } },
      {
        onSuccess: ({ data }) => {
          setShowDialog(false);
          redirect('/events_subscriptions/' + data.id);
        },
        onFailure: error => notify(error.message, 'error')
      }
    );
  };

  return (
    <>
      <Button onClick={() => setShowDialog(true)} label={translate('events_subscriptions.create')}>
        <IconContentAdd />
      </Button>
      <Dialog fullWidth open={showDialog} onClose={() => setShowDialog(false)} maxWidth="sm">
        <DialogTitle>{translate('events_subscriptions.create')}</DialogTitle>
        <FormWithRedirect
          resource="events_subscriptions"
          save={handleSubmit}
          initialValues={{
            associations_id: localStorage.getItem('associations_id')
          }}
          render={({ handleSubmitWithRedirect, pristine, saving }) => (
            <>
              <DialogContent>
                <TextInput fullWidth autoFocus source="name" label={translate('common.name')} validate={[required(), validateMaxLength(255, translate('common.validation.maxLength'))]} />
              </DialogContent>
              <DialogActions>
                <Button label="ra.action.cancel" onClick={() => setShowDialog(false)} disabled={loading}>
                  <IconCancel />
                </Button>
                <SaveButton handleSubmitWithRedirect={handleSubmitWithRedirect} pristine={pristine} saving={saving} disabled={loading} />
              </DialogActions>
            </>
          )}
        />
      </Dialog>
    </>
  );
};

const MyActions = ({ data }) => {
  const translate = useTranslate();
  return (
    <TopToolbar>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'wrap',
          }}>
            <Link to="/settings-events-subscriptions" className="">
              <ArrowBackIosNewIcon className="mr-2" />
            </Link>
            <Typography variant="h5" className="grey8">
              {data && data.name ? data.name : translate('events_subscriptions.title')}
            </Typography>
          </div>
        </Grid>
      </Grid>
    </TopToolbar>
  );
};

export const EventsSubscriptionsEdit = ({ id, ...props }) => {
  const translate = useTranslate();
  const notify = useNotify();
  const redirect = useRedirect();

  const onSuccess = ({ data }) => {
    notify(translate('common.notification.updated'));
    redirect('/settings-events-subscriptions');
  };

  return (
    <Edit
      {...props}
      id={id}
      mutationMode="pessimistic"
      actions={<MyActions {...props} />}
      onSuccess={onSuccess}
      title={<ElementTitle />}
    >
      <TabbedForm toolbar={<FormToolbar />}>
        <FormTab label={translate('classrooms.data')} path="">
          <br/>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <BooleanInput fullWidth source="actived" label={translate('common.actived')} />
            </Grid>
            <Grid item xs={12}>
              <TextInput fullWidth source="name" label={translate('common.name')} validate={[required(), validateMaxLength(255, translate('common.validation.maxLength'))]} />
            </Grid>
            <Grid item xs={12}>
              <RichTextInput source="description" label={translate('common.description')} />
            </Grid>
            <Grid item xs={4}>
              <NumberInput fullWidth source="subscriptions_vat_percent" label={translate('settings.subscriptions_vat_percent')} step={0.01} validate={[required(), minValue(0), maxValue(100)]} />
            </Grid>
            <Grid item xs={4}>
              <NumberInput fullWidth source="total_capacity" label={translate('events_subscriptions.total_capacity')} />
            </Grid>
            <Grid item xs={12}>
              <SubscriptionTypeInput />
            </Grid>
            <Grid item xs={12}>
              <Grid container spacing={2} alignItems="flex-start">
                <Grid item xs={12} md={8}>
                  <RadioButtonGroupInput
                    source="allow_one_ticket_each_event"
                    label={translate('events_subscriptions.tickets_limit_mode')}
                    choices={[
                      { id: true, name: translate('events_subscriptions.tickets_limit_one_each_event') },
                      { id: false, name: translate('events_subscriptions.tickets_limit_max_number') }
                    ]}
                  />
                </Grid>
                <FormDataConsumer>
                  {({ formData }) => formData && (formData.allow_one_ticket_each_event === false || formData.allow_one_ticket_each_event === 'false') ?
                    <Grid item xs={12} md={4}>
                      <NumberInput fullWidth source="max_tickets" label={translate('events_subscriptions.max_tickets')} />
                    </Grid>
                  : null}
                </FormDataConsumer>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <BooleanInput fullWidth source="allow_different_sessions" label={translate('events_subscriptions.allow_different_sessions')} />
            </Grid>
            <Grid item xs={12} md={3}>
              <NumberInput fullWidth source="priority" label={translate('common.priority')} />
            </Grid>
          </Grid>
        </FormTab>
        <FormTab label={translate('events_subscriptions.images')} path="images">
          <DocsList target={targets.EVENTS_SUBSCRIPTION_IMAGE} items_id={id} />
        </FormTab>
        <FormTab label={translate('events_subscriptions.prices')} path="prices">
          <EventsSubscriptionsPricesList events_subscriptions_id={id} />
        </FormTab>
        <FormTab label={translate('events_subscriptions.events')} path="events">
          <EventsSubscriptionsEventsList events_subscriptions_id={id} />
        </FormTab>
      </TabbedForm>
    </Edit>
  );
};

const ElementTitle = ({ record }) => {
  const translate = useTranslate();
  return (<span>{translate('common.edit')} {record ? `"${record.name}"` : ''}</span>);
};

const FormToolbar = props => (
  <Toolbar {...props} className="user_form_toolbar">
    <SaveButton transform={transformSubscriptionData} />
    <DeleteButton redirect="/settings-events-subscriptions" mutationMode="pessimistic" />
  </Toolbar>
);

export const EventsSubscriptionsCreate = props => {
  const translate = useTranslate();
  return (
    <Create {...props}>
      <SimpleForm initialValues={{ associations_id: localStorage.getItem('associations_id') }}>
        <Typography variant="h5" className="grey">{translate('events_subscriptions.create')}</Typography>
        <TextInput fullWidth source="name" label={translate('common.name')} validate={[required(), validateMaxLength(255, translate('common.validation.maxLength'))]} />
      </SimpleForm>
    </Create>
  );
};

const EventsSubscriptionsPricesList = ({ events_subscriptions_id }) => {
  const translate = useTranslate();
  return (
    <ResourceContextProvider value="events_subscriptions_prices">
      <List
        basePath="/events_subscriptions_prices"
        filter={{ events_subscriptions_id }}
        actions={<EventsSubscriptionsPricesCreateButton events_subscriptions_id={events_subscriptions_id} />}
        empty={<EventsSubscriptionsPricesCreateButton events_subscriptions_id={events_subscriptions_id} />}
        bulkActionButtons={false}
        pagination={false}
        perPage={1000}
        sort={{ field: 'priority', order: 'ASC' }}
      >
        <Datagrid rowClick="edit">
          <ReferenceField label={translate('events_sessions_prices.tickets_groups_id')} source="tickets_groups_id" reference="tickets_groups" link={false}>
            <TextField source="name" />
          </ReferenceField>
          <TextField source="price" label={translate('events_sessions_prices.price')} sortable={false} />
          <TextField source="priority" label={translate('common.priority')} sortable={false} />
          <BooleanField source="actived" label={translate('events_sessions_prices.online_sales')} sortable={false} />
          <BooleanField source="box_office_sale_enabled" label={translate('events_sessions_prices.box_office_sales')} sortable={false} />
          <DeleteButton undoable={false} redirect={`/events_subscriptions/${events_subscriptions_id}/prices`} label="" />
        </Datagrid>
      </List>
    </ResourceContextProvider>
  );
};

const EventsSubscriptionsPricesCreateButton = ({ events_subscriptions_id }) => {
  const translate = useTranslate();
  return (
    <TopToolbar>
      <Link to={`/events_subscriptions_prices/create?events_subscriptions_id=${events_subscriptions_id}`}>
        <Button label={translate('events_subscriptions.add_price')}>
          <IconContentAdd />
        </Button>
      </Link>
    </TopToolbar>
  );
};

const EventsSubscriptionsEventsList = ({ events_subscriptions_id }) => {
  const translate = useTranslate();
  return (
    <ResourceContextProvider value="events_subscriptions_events">
      <List
        basePath="/events_subscriptions_events"
        filter={{ events_subscriptions_id }}
        actions={<EventsSubscriptionsEventsCreateButton events_subscriptions_id={events_subscriptions_id} />}
        empty={<EventsSubscriptionsEventsCreateButton events_subscriptions_id={events_subscriptions_id} />}
        bulkActionButtons={false}
        pagination={false}
        perPage={1000}
        sort={{ field: 'priority', order: 'ASC' }}
      >
        <Datagrid rowClick={null}>
          <TextField source="event_name" label={translate('events_subscriptions.event')} sortable={false} />
          <TextField source="priority" label={translate('common.priority')} sortable={false} />
          <EventsSubscriptionsEventsEditButton />
          <DeleteButton undoable={false} redirect={`/events_subscriptions/${events_subscriptions_id}/events`} label="" />
        </Datagrid>
      </List>
    </ResourceContextProvider>
  );
};

const EventsSubscriptionsEventsCreateButton = ({ events_subscriptions_id }) => {
  const [showDialog, setShowDialog] = useState(false);
  const [create, { loading }] = useCreate('events_subscriptions_events');
  const notify = useNotify();
  const translate = useTranslate();
  const refresh = useRefresh();

  const handleSubmit = async values => {
    create(
      { payload: { data: values } },
      {
        onSuccess: () => {
          setShowDialog(false);
          notify(translate('events_subscriptions.event_added'));
          refresh();
        },
        onFailure: error => notify(error.message, 'error')
      }
    );
  };

  return (
    <>
      <TopToolbar>
        <Button onClick={() => setShowDialog(true)} label={translate('events_subscriptions.add_event')}>
          <IconContentAdd />
        </Button>
      </TopToolbar>
      <Dialog fullWidth open={showDialog} onClose={() => setShowDialog(false)} maxWidth="sm">
        <DialogTitle>{translate('events_subscriptions.add_event')}</DialogTitle>
        <FormWithRedirect
          resource="events_subscriptions_events"
          save={handleSubmit}
          initialValues={{ events_subscriptions_id: events_subscriptions_id }}
          render={({ handleSubmitWithRedirect, pristine, saving }) => (
            <>
              <DialogContent>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={9}>
                    <ReferenceInput fullWidth label={translate('events_subscriptions.event')} source="events_id" reference="events" filter={{ associations_id: localStorage.getItem('associations_id'), ticketing: 1 }} perPage={1000} validate={[required()]}>
                      <SelectInput fullWidth optionText="title" optionValue="id" resettable />
                    </ReferenceInput>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <NumberInput fullWidth source="priority" label={translate('common.priority')} />
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions>
                <Button label="ra.action.cancel" onClick={() => setShowDialog(false)} disabled={loading}>
                  <IconCancel />
                </Button>
                <SaveButton handleSubmitWithRedirect={handleSubmitWithRedirect} pristine={pristine} saving={saving} disabled={loading} />
              </DialogActions>
            </>
          )}
        />
      </Dialog>
    </>
  );
};

const EventsSubscriptionsEventsEditButton = ({ record }) => {
  const [showDialog, setShowDialog] = useState(false);
  const [update, { loading }] = useUpdate();
  const notify = useNotify();
  const refresh = useRefresh();
  const translate = useTranslate();

  const handleSubmit = async values => {
    update(
      {
        type: 'update',
        resource: 'events_subscriptions_events',
        payload: { id: values.id, data: values }
      },
      {
        onSuccess: () => {
          setShowDialog(false);
          refresh();
        },
        onFailure: error => notify(error.message, 'error')
      }
    );
  };

  return (
    <>
      <Button onClick={() => setShowDialog(true)} label="" startIcon={<EditIcon />} title={translate('common.edit')} aria-label={translate('common.edit')} />
      <Dialog fullWidth open={showDialog} onClose={() => setShowDialog(false)} maxWidth="sm">
        <DialogTitle>{translate('common.edit')}</DialogTitle>
        <FormWithRedirect
          resource="events_subscriptions_events"
          save={handleSubmit}
          initialValues={record}
          render={({ handleSubmitWithRedirect, pristine, saving }) => (
            <>
              <DialogContent>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={9}>
                    <ReferenceInput fullWidth label={translate('events_subscriptions.event')} source="events_id" reference="events" filter={{ associations_id: localStorage.getItem('associations_id'), ticketing: 1 }} perPage={1000} validate={[required()]}>
                      <SelectInput fullWidth optionText="title" optionValue="id" resettable />
                    </ReferenceInput>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <NumberInput fullWidth source="priority" label={translate('common.priority')} />
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions>
                <Button label="ra.action.cancel" onClick={() => setShowDialog(false)} disabled={loading}>
                  <IconCancel />
                </Button>
                <SaveButton handleSubmitWithRedirect={handleSubmitWithRedirect} pristine={pristine} saving={saving} disabled={loading} />
              </DialogActions>
            </>
          )}
        />
      </Dialog>
    </>
  );
};

const subscriptionPriceDefaults = () => {
  const year = new Date().getFullYear();
  const start = new Date(year, 0, 1).toISOString();
  const finish = new Date(year + 1, 0, 1).toISOString();
  return { actived: true, box_office_sale_enabled: true,
    publication_start: start, publication_finish: finish,
    sale_start: start, sale_finish: finish, box_office_start: start, box_office_finish: finish };
};

const subscriptionPeriodDates = (startField, finishField) => (value, values) => {
  if (!value || !values || !values[startField] || !values[finishField]) return undefined;
  const start = new Date(values[startField]).getTime();
  const finish = new Date(values[finishField]).getTime();
  if (Number.isNaN(start) || Number.isNaN(finish)) return undefined;
  return finish > start ? undefined : 'common.validation.date_finish_after_start';
};

const SubscriptionPricePeriods = () => {
  const translate = useTranslate();
  return <FormDataConsumer>{({ formData }) => <>
    <Grid item xs={12}><Typography variant="h6" sx={{ mt: 2 }}>{translate('events_subscriptions.publication_period')}</Typography></Grid>
    <Grid item xs={12} sm={6}>
      <DateTimeInput fullWidth source="publication_start" label={translate('events_subscriptions.publication_start')} parse={dateParser} validate={[subscriptionPeriodDates('publication_start', 'publication_finish')]} />
    </Grid>
    <Grid item xs={12} sm={6}>
      <DateTimeInput fullWidth source="publication_finish" label={translate('events_subscriptions.publication_finish')} parse={dateParser} validate={[subscriptionPeriodDates('publication_start', 'publication_finish')]} />
    </Grid>
    <Grid item xs={12}><Typography variant="h6" sx={{ mt: 2 }}>{translate('events_sessions_prices.online_sales')}</Typography></Grid>
    <Grid item xs={12} sm={2}>
      <BooleanInput fullWidth source="actived" label={translate('events_sessions_prices.actived')} />
    </Grid>
    <Grid item xs={12} sm={5}>
      <DateTimeInput fullWidth source="sale_start" label={translate('events_sessions_prices.sale_start')} parse={dateParser} disabled={!formData.actived} validate={[subscriptionPeriodDates('sale_start', 'sale_finish')]} />
    </Grid>
    <Grid item xs={12} sm={5}>
      <DateTimeInput fullWidth source="sale_finish" label={translate('events_sessions_prices.sale_finish')} parse={dateParser} disabled={!formData.actived} validate={[subscriptionPeriodDates('sale_start', 'sale_finish')]} />
    </Grid>
    <Grid item xs={12}><Typography variant="h6" sx={{ mt: 2 }}>{translate('events_sessions_prices.box_office_sales')}</Typography></Grid>
    <Grid item xs={12} sm={2}>
      <BooleanInput fullWidth source="box_office_sale_enabled" label={translate('events_sessions_prices.box_office_sale_enabled')} />
    </Grid>
    <Grid item xs={12} sm={5}>
      <DateTimeInput fullWidth source="box_office_start" label={translate('events_sessions_prices.box_office_start')} parse={dateParser} disabled={!formData.box_office_sale_enabled} validate={[subscriptionPeriodDates('box_office_start', 'box_office_finish')]} />
    </Grid>
    <Grid item xs={12} sm={5}>
      <DateTimeInput fullWidth source="box_office_finish" label={translate('events_sessions_prices.box_office_finish')} parse={dateParser} disabled={!formData.box_office_sale_enabled} validate={[subscriptionPeriodDates('box_office_start', 'box_office_finish')]} />
    </Grid>
  </>}</FormDataConsumer>;
};

export const EventsSubscriptionsPricesCreate = props => {
  const translate = useTranslate();
  const search = new URLSearchParams(props.location.search);
  const eventsSubscriptionsId = search.get('events_subscriptions_id');
  return (
    <Create {...props}>
      <SimpleForm redirect={`/events_subscriptions/${eventsSubscriptionsId}/prices`} initialValues={{ events_subscriptions_id: eventsSubscriptionsId, ...subscriptionPriceDefaults() }}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <ReferenceInput fullWidth label={translate('events_sessions_prices.tickets_groups_id')} source="tickets_groups_id" reference="tickets_groups" filter={{ associations_id: localStorage.getItem('associations_id') }} perPage={1000} sort={{ field: 'priority', order: 'ASC' }} validate={[required()]}>
              <SelectInput fullWidth optionText="name" optionValue="id" resettable />
            </ReferenceInput>
          </Grid>
          <Grid item xs={12} md={3}>
            <NumberInput fullWidth source="price" label={translate('events_sessions_prices.price')} validate={[required()]} />
          </Grid>
          <Grid item xs={12} md={3}>
            <NumberInput fullWidth source="priority" label={translate('common.priority')} />
          </Grid>
          <SubscriptionPricePeriods />
        </Grid>
      </SimpleForm>
    </Create>
  );
};

export const EventsSubscriptionsPricesEdit = props => {
  const translate = useTranslate();
  const notify = useNotify();
  const redirect = useRedirect();

  const onSuccess = ({ data }) => {
    notify(translate('common.notification.updated'));
    redirect('/events_subscriptions/' + data.events_subscriptions_id + '/prices');
  };

  return (
    <Edit {...props} mutationMode="pessimistic" onSuccess={onSuccess}>
      <SimpleForm>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <ReferenceInput fullWidth label={translate('events_sessions_prices.tickets_groups_id')} source="tickets_groups_id" reference="tickets_groups" filter={{ associations_id: localStorage.getItem('associations_id') }} perPage={1000} sort={{ field: 'priority', order: 'ASC' }} validate={[required()]}>
              <SelectInput fullWidth optionText="name" optionValue="id" resettable />
            </ReferenceInput>
          </Grid>
          <Grid item xs={12} md={3}>
            <NumberInput fullWidth source="price" label={translate('events_sessions_prices.price')} validate={[required()]} />
          </Grid>
          <Grid item xs={12} md={3}>
            <NumberInput fullWidth source="priority" label={translate('common.priority')} />
          </Grid>
          <SubscriptionPricePeriods />
        </Grid>
      </SimpleForm>
    </Edit>
  );
};

export const EventsSubscriptionsEventsCreate = props => {
  const translate = useTranslate();
  const search = new URLSearchParams(props.location.search);
  const eventsSubscriptionsId = search.get('events_subscriptions_id');
  return (
    <Create {...props}>
      <SimpleForm redirect={`/events_subscriptions/${eventsSubscriptionsId}/events`} initialValues={{ events_subscriptions_id: eventsSubscriptionsId }}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={9}>
            <ReferenceInput fullWidth label={translate('events_subscriptions.event')} source="events_id" reference="events_subscriptions/events" filter={{ associations_id: localStorage.getItem('associations_id') }} perPage={1000} validate={[required()]}>
              <SelectInput fullWidth optionText="name" optionValue="id" resettable />
            </ReferenceInput>
          </Grid>
          <Grid item xs={12} md={3}>
            <NumberInput fullWidth source="priority" label={translate('common.priority')} />
          </Grid>
        </Grid>
      </SimpleForm>
    </Create>
  );
};

export const EventsSubscriptionsEventsEdit = props => {
  const translate = useTranslate();
  return (
    <Edit {...props} mutationMode="pessimistic">
      <SimpleForm>
        <ReferenceInput label={translate('events_subscriptions.event')} source="events_id" reference="events" filter={{ associations_id: localStorage.getItem('associations_id'), ticketing: 1 }} perPage={1000} validate={[required()]}>
          <SelectInput optionText="title" optionValue="id" resettable />
        </ReferenceInput>
        <NumberInput fullWidth source="priority" label={translate('common.priority')} />
      </SimpleForm>
    </Edit>
  );
};
